<template>
  <div class="container">
    <div class="theme">
        <span>テーマ<span>Theme</span></span>
        
    </div>
    <div class="title">
        <span>{{title}}</span>
    </div>
  </div>
</template>

<script>
export default {
  name: "title-component",
  props: ["title"],
  data() {
    return {};
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
@import "../../assets/style/common.scss";

.container {
  display: flex;
  border: 2px solid #573F23;
  align-items: stretch;
  border-radius: 8px;
  background:#fff;
  height:65px;

   @include mq-down(md) { 
     height:55px;
   }
  
}
.theme {
  border-right: 1px solid #573F23;
  width: 120px;
  display: flex;
  justify-content: center; /* 子要素をflexboxにより中央に配置する */
  align-items: center; /* 子要素をflexboxにより中央に配置する */
  & > span {
    display: table-cell;
    color:#39af78;
    font-weight: 600;
    & > span{
      display:block;
      margin-top:1px;
      margin-left:5px;
      color:silver;
      font-size:12px;
      font-weight:normal;
    }
  }

   @include mq-down(md) { 
     width:80px;
      font-size: 14px;
   }

}
.title {
  padding-left: 20px;
  font-size: 1.5em;
  font-weight: 900;
  color: rgb(241, 241, 146);
  display: flex;
  justify-content: center; /* 子要素をflexboxにより中央に配置する */
  align-items: center; /* 子要素をflexboxにより中央に配置する */
  
  //縁取り文字
  -webkit-text-stroke-width: 1px;
  -webkit-text-stroke-color: #666;
  text-shadow: 1px 2px 0px #666; 

  @include mq-down(md) { 
          font-size: 16px;
   }

}
</style>



// WEBPACK FOOTER //
// src/components/atoms/Title.vue